import React from 'react';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import { useTranslation } from 'react-i18next';
import { TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import TopRowTitle from '../../claim_group/overview/TopRowTitle';
const CONTRACTOR_KEYS_VERSION_7 = [{
  key: 'dcr_remun_paid',
  translationKey: 'dcr_remun_paid'
}, {
  key: 'not_in_20_26',
  translationKey: 'dcr_remun_paid_not_in_20_26'
}, {
  key: 'in_20_26',
  translationKey: 'dcr_remun_paid_in_20_26'
}];
const CONTRACTOR_KEYS_VERSION_8 = [{
  key: 'dcr_remun_paid',
  translationKey: 'dcr_remun_paid'
}, {
  key: 'before_28_3_24',
  translationKey: 'dcr_remun_paid_before_28_3_24'
}, {
  key: 'after_27_3_24',
  translationKey: 'dcr_remun_paid_after_27_3_24'
}];
const ContractorInvoiceTotals = _ref => {
  let {
    contractor,
    isVersion8
  } = _ref;
  const {
    t
  } = useTranslation();
  const contractorKeys = isVersion8 ? CONTRACTOR_KEYS_VERSION_8 : CONTRACTOR_KEYS_VERSION_7;
  const renderContractors = contractorKeys.map(contractorFieldName => {
    return /*#__PURE__*/React.createElement("div", {
      key: contractorFieldName.key
    }, /*#__PURE__*/React.createElement(TextFormFieldRow, {
      fieldName: contractorFieldName.key,
      value: contractor.invoice_totals[contractorFieldName.key],
      label: t(contractorFieldName.translationKey),
      disabled: true,
      dataTestId: "contractor-invoice-total-".concat(contractorFieldName.key),
      labelColSpan: 5
    }));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Details of contract research (must be completed per contractor)'))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: '600px'
    }
  }, renderContractors));
};
export default ContractorInvoiceTotals;